import React from "react";
const MagnifierIcon = (props) => (React.createElement("svg", Object.assign({ width: "21", height: "21", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20.226 18.778l-5.522-5.521a8.216 8.216 0 10-1.447 1.447l5.521 5.522a1.023 1.023 0 001.448-1.448zM2.104 8.244a6.14 6.14 0 116.14 6.14 6.147 6.147 0 01-6.14-6.14z", fillRule: "nonzero" })));
export default MagnifierIcon;
